import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  PasswordInput,
  AutocompleteInput,
  useNotify,
  useRedirect,
} from "react-admin";

const validateEmail = (value) => {
  if (!value) return undefined;
  return /^[^\s@]+@[^\s@]+\.com$/i.test(value)
    ? undefined
    : "Email must be in the format name@example.com";
};

const validatePassword = (value) => {
  if (!value) return undefined;
  return value.length >= 6 ? undefined : "Password must be at least 6 characters";
};

const UserCreate = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = ({ data }) => {
    notify("User created");
    redirect(`/users/${data.id}`);
  };

  const onFailure = () => {
    notify("Failed to create user. Please try again.", "warning");
  };

  return (
    <Create title={`Create User`} onSuccess={onSuccess} onFailure={onFailure} {...props}>
      <SimpleForm validateOnBlur>
        <TextInput source="name" />
        <TextInput source="email" validate={validateEmail} />
        <PasswordInput source="password" validate={validatePassword} />
        <AutocompleteInput
          source="role"
          choices={[
            { id: "admin", name: "Admin" },
            { id: "user", name: "User" },
            { id: "uploader", name: "Uploader" },
          ]}
        />
      </SimpleForm>
    </Create>
  );
};

export default UserCreate;
